module.exports = __webpack_public_path__ + "img/icon_solution02.58c0b3ea.png";